import React, { useContext, useState, useEffect, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { SWRConfig } from "swr";
import fetcher from "./lib/fetcher";
import authContext from "./context/auth";
import { Navigations, NavDataTypes } from "./constants/routes";
import "./App.css";
// Lazy load Login page
const Login = lazy(() => import("./pages/Login"));

const swrConf = { fetcher };

const App: React.FC = () => {
  const auth = useContext(authContext);
  const [authenticated, setAuthenticated] = useState(auth.authenticated);

  useEffect(() => {
    setAuthenticated(auth?.authenticated);
  }, [auth]);

  return (
    <SWRConfig value={swrConf}>
      <authContext.Provider value={{ authenticated, setAuthenticated }}>
        <BrowserRouter>
          <Suspense fallback={<div>Loading page...</div>}>
            <Routes>
              <Route index element={!authenticated.auth ? <Login /> : <Navigate to="/dashboard" />} />
              {Navigations.map((nav: NavDataTypes, i: number) => (
                <Route
                  path={nav.path}
                  key={i}
                  element={!authenticated.auth && nav.authRequire ? <Navigate to="/" /> : nav.component}
                />
              ))}
            </Routes>
          </Suspense>
        </BrowserRouter>
      </authContext.Provider>
    </SWRConfig>
  );
};

export default App;
